export default __webpack_public_path__ + "static/media/default.e373d46a.svg";